<template>
  <div>
    <form id="form" @submit.prevent="">
      <div class="form-group">
        <label>وضعیت</label>
        <div class="row">
          <div class="form-group col-3">
            <label>پمپ</label>
            <div class="radio-inline">
              <label class="radio">
                <input type="radio" :value="1" v-model="form.p1" />
                <span></span>
                روشن
              </label>
              <label class="radio">
                <input type="radio" :value="0" v-model="form.p1" />
                <span></span>
                خاموش
              </label>
            </div>
          </div>
          <div class="form-group col-3">
            <label>موتور</label>
            <div class="radio-inline">
              <label class="radio">
                <input type="radio" :value="1" v-model="form.p2" />
                <span></span>
                روشن
              </label>
              <label class="radio">
                <input type="radio" :value="0" v-model="form.p2" />
                <span></span>
                خاموش
              </label>
            </div>
          </div>
          <div class="form-group col-3" v-if="form.p2">
            <label>سرعت</label>
            <div class="radio-inline">
              <label class="radio">
                <input type="radio" :value="1" v-model="form.p3" />
                <span></span>
                روشن
              </label>
              <label class="radio">
                <input type="radio" :value="0" v-model="form.p3" />
                <span></span>
                خاموش
              </label>
            </div>
          </div>
        </div>
        <span class="form-text text-muted">choose touch panel status</span>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "TP1",
  data() {
    return {
      form: {}
    };
  },
  computed: {
    ...mapGetters(["device"]),
    originalForm() {
      let status = this.device.status.toString();
      status = status === "" ? "00" : status;
      return {
        id: this.device.id,
        name: this.device.name,
        p1: parseInt(status.charAt(0)),
        p2: status.charAt(1) !== "0" ? 1 : 0,
        p3: status.charAt(1) === "2" ? 1 : 0
      };
    }
  },
  methods: {
    convertKeys() {
      if (!this.form.p1) {
        this.form.status = "00";
      }
      if (this.form.p1 && !this.form.p2) {
        this.form.status = "10";
      }
      if (this.form.p1 && this.form.p2) {
        if (this.form.p3) {
          this.form.status = "12";
        } else {
          this.form.status = "11";
        }
      }
    }
  },
  beforeMount() {
    this.form = _.cloneDeep(this.originalForm);
  },
  watch: {
    form: {
      handler() {
        this.convertKeys();
        // if (_.isEqual(this.form, this.originalForm) === false) {
        this.$emit("change-form", this.form.status);
        // }
      },
      deep: true
    }
  }
};
</script>
